export const environment = {
  production: false,
  apiEndpoint: "https://uatwebapi.carwinsauto-official.com",
  cached : true,
  recaptcha: {
    siteKey: '6LclSngsAAAAABYsqwyU8fVOBtzWPCmlKrA1DTtb',
  },
};
